import React, { ReactNode } from 'react';

export const StartedFrom = ({
  payload,
  ignorePrephrase = false,
}: {
  payload: ReactNode;
  ignorePrephrase?: boolean;
}) => (
  <div className="incoming-message__reply">
    <div className="incoming-message__reply-text">
      {!ignorePrephrase && (
        <span>
          <b> Conversation started from: </b>
        </span>
      )}
      <span>{payload}</span>
    </div>
  </div>
);
